// 仅通知读接口由页面自行处理失败，不把后台检查失败当作全局退出登录。
export const isQuietNotificationRequest=(config:any):boolean=>{
  if(config?.quietNotification!==true)return false
  const url=String(config.url || '').replace(/^\//,'').split('?')[0]
  const method=String(config.method || 'get').toLowerCase()
  return method==='get' && /^customer\/securityNotifications(?:\/[1-9]\d*)?$/.test(url)
    || method==='post' && /^customer\/securityNotifications\/(read|readAll)$/.test(url)
}
